'use client';

import { useEffect } from 'react';
import NextLink from 'next/link';
import { Button } from '@pie/amber';
import { processError } from '@/lib/processError';
import { PageContainer } from '@/components/Page/PageContainer';
import { PageError } from '@/components/Page/PageError';

export default function AppErrorPage({
  error,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    processError(error);
  }, [error]);

  return (
    <PageContainer>
      <PageError
        actions={
          <Button
            as={NextLink}
            emphasis="heavy"
            href="/support"
            size="md"
            tone="neutral"
            weight="body-strong"
          >
            Contact Support
          </Button>
        }
        heading="Something Went Wrong"
        helpText="Try again later."
      />
    </PageContainer>
  );
}
